
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

const RowWithTotalCount = ({ texts, totalCount }) => (
  <div className="selection-summary center">
    <div>
      <div className="column">
        <span className="text count">{`${texts['total']}:`}</span>
        &nbsp;
        <span className="value">{totalCount}</span>
      </div>
    </div>
  </div>
);

RowWithTotalCount.propTypes = {
  totalCount: PropTypes.number.isRequired,
  texts: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    texts: state.app.texts,
    totalCount: state.transcriptViewer.totalCount,
  }), dispatch => bindActionCreators({}, dispatch),
)(RowWithTotalCount);
